import { render, staticRenderFns } from "./orgConfig.vue?vue&type=template&id=6ce19e85"
import script from "./orgConfig.vue?vue&type=script&lang=js"
export * from "./orgConfig.vue?vue&type=script&lang=js"
import style0 from "./orgConfig.vue?vue&type=style&index=0&id=6ce19e85&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports